import React from 'react';
import { Image, StyleSheet, View, Platform } from 'react-native';

interface AvatarProps {
  size: number;
  avatarUrl?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ size, avatarUrl }) => {
  const styles = StyleSheet.create({
    container: {
      width: size,
      height: size,
      borderRadius: size / 2,
      overflow: 'hidden',
      backgroundColor: '#4B7FDB',
      ...(Platform.OS === 'web' && {
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }),
    },
    image: {
      width: '100%',
      height: '100%',
    },
  });

  const source = avatarUrl 
    ? { uri: avatarUrl }
    : require('@assets/avatars/default_avatar.webp');

  return (
    <View style={styles.container}>
      <Image
        source={source}
        style={styles.image}
        resizeMode="cover"
      />
    </View>
  );
};

export default Avatar;
